import Vue from 'vue';
import VueHtmlToPaper from 'vue-html-to-paper';

const options = {
    name: '_blank',
    specs: [
        'fullscreen=yes',
        'titlebar=yes',
        'scrollbars=yes'
    ],
    // Lokal ausgeliefert (public/print/), damit beim Drucken keine Anfragen an CDNs gehen.
    // Absolute URLs, weil das Druckfenster ein leeres about:blank-Dokument ist.
    styles: [
        `${window.location.origin}/print/bootstrap.min.css`,
        `${window.location.origin}/print/kidlat.css`
    ],
    timeout: 1000, // default timeout before the print window appears
    autoClose: true, // if false, the window will not close after printing
    windowTitle: window.document.title, // override the window title
}


export default Vue.use(VueHtmlToPaper, options);